import { render, staticRenderFns } from "./ktcgpfList.vue?vue&type=template&id=6721ec5c&"
import script from "./ktcgpfList.vue?vue&type=script&lang=js&"
export * from "./ktcgpfList.vue?vue&type=script&lang=js&"
import style0 from "./ktcgpfList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports